import { createRoot } from "react-dom/client";
import { StoreProvider } from "../app/storeProvider";
import DreamCarCompetition from "../app/(general-header)/prizes/cars/page";

const root = createRoot(document.getElementById("dream-car-container") as HTMLElement);

root.render(
  <StoreProvider>
    <DreamCarCompetition />
  </StoreProvider>
);
